import * as moment from 'moment';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { LoginResponse, AccessTokenResponse } from '../../models/login';
import { MasterConstants } from '../../common/constants/master-constants';
import { LocalStorageService } from './local-storage.service';
import { LoaderService } from './loader.service';
import { SharedDataService } from './shared-data.service';
import { LolLoggerService } from './../../common/shared/lol-logger.service';
import { ApplicationInsightsService } from '../common/application-insights-service.service';

@Injectable()
export class NetworkService {
  headerYear: any = '';
  headerCompany: any = '';
  userId: any = '';
  accessToken: any = '';
  appVersion: string = '';
  isReloadDetected: boolean = false;

  constructor(public http: HttpClient, public dataService: SharedDataService,
    public router: Router, public localStorageService: LocalStorageService,
    private applicationInsightsService: ApplicationInsightsService,
    private loaderService: LoaderService) { }

  getRequest(url: string, additionalHeaders?: LoginResponse) {
    this.applicationInsightsService.logPageView();
    this.SaveRequestTime();
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    if (this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE)) {
      this.headerCompany = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE));
    }

    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const evolveData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (evolveData) {
        this.userId = evolveData.resultData[0].userId;
      }
    }

    const tokenResponse: AccessTokenResponse = this.dataService.getInstance().dataStore[SharedDataService.accessToken];

    if (this.localStorageService.get('token')) {
      this.accessToken = this.localStorageService.get('token');
    }
    else {
      this.accessToken = '';
    }

    if (this.headerYear != '' || this.headerCompany != '') {
      if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
        this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
      }

      if (this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE)) {
        this.headerCompany = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE));
      }
    }

    if (this.localStorageService.get(MasterConstants.APP_VERSION)) {
      this.appVersion = this.localStorageService.get(MasterConstants.APP_VERSION);
    }
    else {
      this.appVersion = '';
    }

    const headers = new HttpHeaders({
      'AppVersion': this.appVersion,
      'Token': this.accessToken,
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'agent': 'web',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    }).set('cropYear', this.headerYear.toString())
      .set('UserId', this.userId)
      .set('companyCode', this.headerCompany);// add paramerter
    // ... Set content type to JSON
    if (additionalHeaders) {
      headers.append('userid', additionalHeaders.UserId);
      headers.append('role', additionalHeaders.UserRoleName);

      LolLoggerService.info(url, additionalHeaders.BusinessSegment);
      if (additionalHeaders.BusinessSegment != null) {
        headers.append('business_segment', additionalHeaders.BusinessSegment);
      }
    }
    if (localStorage.getItem('errorCodeLocal')) { localStorage.removeItem('errorCodeLocal'); }
    if (tokenResponse) {
      try {
        const currentmoment = moment(Date.now()).unix();
        // console.log('currentmoment',moment.unix( currentmoment));
        // console.log("tokenResponse.Current_Expires_Time", moment.unix(tokenResponse.Current_Expires_Time));
        if (currentmoment >= tokenResponse.Current_Expires_Time) {
          localStorage.setItem('errorCodeLocal', 'expired');
          LolLoggerService.info('errorCodeLocal', 'nt expired');
          this.router.navigate(['']);
        }
      } catch (error) {
        LolLoggerService.info('Error block inside network');
      }

      headers.append('Id_Token', tokenResponse.Id_Token);
    }

    const options = { headers: headers }; // Create a request option
    return this.http.get(url, options)
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  postRequest(url: string, body: Object, additionalHeaders?: LoginResponse, code?: string) {
    this.applicationInsightsService.logPageView();
    this.SaveRequestTime();
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    if (this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE)) {
      this.headerCompany = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE));
    }
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const evolveData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (evolveData) {
        this.userId = evolveData.resultData[0].userId;
      }
    }

    if (this.localStorageService.get('token')) {
      this.accessToken = this.localStorageService.get('token');
    }
    else {
      this.accessToken = '';
    }

    if (this.localStorageService.get(MasterConstants.APP_VERSION)) {
      this.appVersion = this.localStorageService.get(MasterConstants.APP_VERSION);
    }
    else {
      this.appVersion = '';
    }

    const headers = new HttpHeaders({
      'AppVersion': this.appVersion,
      'Token': this.accessToken,
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'agent': 'web',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    }).set('cropYear', this.headerYear.toString())
      .set('UserId', this.userId)
      .set('companyCode', this.headerCompany);// add paramerter // ... Set content type to JSON

    const tokenResponse: AccessTokenResponse = this.dataService.getInstance().dataStore[SharedDataService.accessToken];
    if (additionalHeaders != null) {
      headers.append('userid', additionalHeaders.UserId);
      headers.append('role', additionalHeaders.UserRoleName);
      if (additionalHeaders.BusinessSegment != null) {
        headers.append('business_segment', additionalHeaders.BusinessSegment);
      }
    }
    if (localStorage.getItem('errorCodeLocal')) { localStorage.removeItem('errorCodeLocal'); }
    if (tokenResponse && code == null) {
      try {
        const currentmoment = moment(Date.now()).unix();
        // console.log('currentmoment',moment.unix( currentmoment));
        // console.log("tokenResponse.Current_Expires_Time", moment.unix(tokenResponse.Current_Expires_Time));
        if (currentmoment >= tokenResponse.Current_Expires_Time) {
          localStorage.setItem('errorCodeLocal', 'expired');
          LolLoggerService.info('errorCodeLocal', 'nt expired');
          this.router.navigate(['']);
        }
      } catch (error) {
        LolLoggerService.info('error block inside post network');
      }

      headers.append('Id_Token', tokenResponse.Id_Token);
    }

    if (code && code != 'logout') {
      headers.append('code', code);
    }
    else if (code == 'logout') {
      LolLoggerService.info('tokenResponse in logout', tokenResponse);
      if (tokenResponse) {
        headers.append('access_token', tokenResponse.Access_Token);
        this.dataService.deleteUserInformation();
      }
    }
    const options = { headers: headers }; // Create a request option
    return this.http.post(url, body, options)
      .pipe(
        map(res => res), catchError(this.handleError.bind(this)));
  }

  handleError(error) {
    let errorMessage = '';
    this.loaderService.setLoaderStatus(false);

    console.log('error - ', error);

    if (!this.isReloadDetected && error && error.error && error.error.text) {
      console.log('error.error.text - ', error.error.text);

      var errorTextArr = error.error.text.split(' ');

      if (errorTextArr[0] == "AppVersionMismatch") {
        this.isReloadDetected = true;

        console.log('AppVersion - ', errorTextArr[1]);
        this.localStorageService.set(MasterConstants.APP_VERSION, errorTextArr[1]);
        window.location.reload();
      }
      else if (errorTextArr[0] == "TokenExpired") {
        this.isReloadDetected = true;
        console.log('TokenExpired');
        this.localStorageService.remove('token');
        this.localStorageService.remove('refreshToken');
        this.localStorageService.remove('tokenExpiry');
        window.location.reload();
      }
    }
    else if (error.status == '401' && error.error.message == 'Token Expired') {
      window.location.href = error.error.url;
      //return throwError(error);
    }
    else if (error.status == '401') {
      this.router.navigate(['/unauthorize']);
    }
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
      return throwError(errorMessage);
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
      return throwError(errorMessage);
    }
  }

  SaveRequestTime() {
    // used to show logout popup
    if (typeof (Storage) !== 'undefined') {
      localStorage.setItem('loginTime', new Date().getTime().toString());
    }
  }
}
